/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Profile from "../assets/profile-image2-min.jpg";
import doctrace from "../assets/Main-banner-mockup.png";
import skill from "../assets/blur-close-up-computer-keyboard-459737-min.jpg";
import ria from "../assets/ria.png";
import slm from "../assets/slm.png";
import { Waypoint } from "react-waypoint";
// import ReactGA from "react-ga";
import Drift from "react-driftjs";
import { Experiment, Variant } from "react-optimize";

function Main() {
  const [showHeader, setShowHeader] = React.useState(false);
  const [shownav, setShowNav] = React.useState(false);
  const [variant, setvariant] = React.useState('');

  const page = React.useRef("");
  const page2 = React.useRef("");
  const page3 = React.useRef("");

  const showheaderHandler = () => {
    setShowHeader(false);
  };
  const hideheaderHandler = () => {
    setShowHeader(true);
  };
  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  const scroll = () => {
    page.current.scrollIntoView({ behavior: "smooth" });
  };
  const scroll2 = () => {
    page2.current.scrollIntoView({ behavior: "smooth" });
  };
  const scroll3 = () => {
    page3.current.scrollIntoView({ behavior: "smooth" });
  };
  const shownavhandler = () => {
    setShowNav(!shownav);
  };
  // const gaEvent = (event) => {
  //   ReactGA.event({
  //     category: event,
  //     action: event,
  //   });
  // };
  React.useEffect(() => {
    const call = async() => {
      if (window.dataLayer) {
        await window.dataLayer.push({ event: "optimize.activate" });
      }
      const intervalId = setInterval(() => {
        if (window.google_optimize !== undefined) {
          const variant = window.google_optimize.get('QFXBpReIQa-ZSFIaQlU1ZQ');
          setvariant(variant)
          clearInterval(intervalId);
        }
      }, 100);
    }
call()
  },[])
  console.log(variant)
  return (
    <React.Fragment>
    <Drift appId="24a5zaemgvud" />
      <header id="home" class="page-section">
        <div class="bg-img">
          <div class="container">
            <nav
              class={
                showHeader
                  ? "waypoint navbar navbar-expand-sm navbar-dark fixed-top p-0"
                  : "navbar navbar-expand-sm navbar-dark fixed-top p-0"
              }
            >
              <a class="navbar-brand p-4 " onClick={scroll}>
                Portfolio
              </a>

              <button
                onClick={shownavhandler}
                class="navbar-toggler m-4"
                data-toggle="collapse"
                data-target="#navbarCollapse"
              >
                <i class="fa fa-bars"></i>
              </button>
              <div
                class={
                  shownav
                    ? "collapse navbar-collapse show"
                    : "collapse navbar-collapse"
                }
                id="navbarCollapse"
              >
                <ul class="navbar-nav ml-auto text-center">
                  <li class="nav-item">
                    <a
                      class="nav-link text-white active"
                      onClick={() => {
                        scroll();
                        // gaEvent("home");
                      }}
                    >
                      Home
                    </a>
                  </li>

                  <li class="nav-item">
                    <a
                      class="nav-link text-white"
                      onClick={() => {
                        scroll2();
                        // gaEvent("about");
                      }}
                    >
                      About
                    </a>
                  </li>

                  <li class="nav-item">
                    <a
                      class="nav-link text-white"
                      onClick={() => {
                        scroll3();
                        // gaEvent("projects");
                      }}
                    >
                      Projects
                    </a>
                  </li>

                  <li class="nav-item">
                    {/* <Link to='/resume' class="nav-link text-white">Profile</Link> */}
                    <a
                      href="https://drive.google.com/file/d/1G632tdS5n6n1_upFbmQb4bOlejNO1Jru/view"
                      target="_blank"
                      class="nav-link text-white"
                      // onClick={() => gaEvent("profile")}
                    >
                      Profile
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>

          <div class="rw-wrapper" ref={page}>
            <div class="container">
              <div class="title">
                <h2>
                  Hello,<span>i'm</span>
                </h2>

                <h2>
                  satish <span>pillai</span>
                </h2>

                <h2>
                  i'm <span>a</span>
                </h2>

                <h2>
                  web <span>developer</span>
                </h2>
              </div>

              <div class="scroll-downs">
                <div class="mousey">
                  <div class="scroller"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <Waypoint
        onEnter={({ previousPosition }) => {
          if (previousPosition === "below") {
            showheaderHandler();
          }
        }}
        onLeave={({ currentPosition }) => {
          if (currentPosition === "above") {
            hideheaderHandler();
          } else {
            showheaderHandler();
          }
        }}
        bottomOffset="600px"
      />
      <section class="profile-section page-section" id="about">
        <div class="container" ref={page2}>
          <div class="row">
            <div class="col-md-3 col-sm-4">
              <div class="d-flex flex-column">
                <img
                  class="img-fluid mb-3 rounded-circle profile-img"
                  src={Profile}
                />
              </div>
            </div>

            <div class="col-lg-8 col-md-8 quote">
              <div class="d-flex flex-column">
                <blockquote class="blockquote">
                  <i class="fa fa-quote-left"></i>
                  An energetic and imaginative young web developer who is able
                  to work alongside other talented IT professionals in creating
                  websites to the very highest standards.
                </blockquote>
              </div>
            </div>
          </div>

          <div class="col-lg-12 col-md-12">
            <h2 class="item-heading ml-4 mt-5">My Skill</h2>

            <div class="row d-flex justify-content-around ">
              <div class="project d-flex flex-row justify-content-around col-lg-3 ">
                <div class="project__card">
                  <div class="d-flex flex-row col-lg-3">
                    <div class="d-flex flex-column showcase">
                      <div class="card feature-card">
                        <img class="card-img-top" src={skill} />

                        <div class="card-img-overlay projectOverlay d-flex flex-column align-items-center">
                          <h4
                            class="card-title"
                            style={{ color: "#ff9f1a", fontSize: "28px" }}
                          >
                            React
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Experiment id="jdbVwI33Qnm1C9C5hCaIAA">
              <Variant id="0">
              <div class="project d-flex flex-row justify-content-around col-lg-3 ">
                <div class="project__card ">
                  <div class="d-flex flex-row col-lg-3">
                    <div class="d-flex flex-column showcase">
                      <div class="card feature-card">
                        <img class="card-img-top" src={skill} />

                        <div class="card-img-overlay projectOverlay d-flex flex-column align-items-center">
                          <h4
                            class="card-title"
                            style={{ color: "#ff9f1a", fontSize: "28px" }}
                          >
                            Redux
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </Variant>
              <Variant id="1">
              <div class="project d-flex flex-row justify-content-around col-lg-3 ">
                <div class="project__card ">
                  <div class="d-flex flex-row col-lg-3">
                    <div class="d-flex flex-column showcase">
                      <div class="card feature-card">
                        <img class="card-img-top" src={skill} />

                        <div class="card-img-overlay projectOverlay d-flex flex-column align-items-center">
                          <h4
                            class="card-title"
                            style={{ color: "#ff9f1a", fontSize: "28px" }}
                          >
                            Redux-toolkit
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                </Variant>
              </Experiment>
              <div class="project d-flex flex-row justify-content-around col-lg-3 ">
                <div class="project__card">
                  <div class="d-flex flex-row col-lg-3">
                    <div class="d-flex flex-column showcase">
                      <div class="card feature-card">
                        <img class="card-img-top" src={skill} />

                        <div class="card-img-overlay projectOverlay d-flex flex-column align-items-center">
                          <h4
                            class="card-title"
                            style={{ color: "#ff9f1a", fontSize: "28px" }}
                          >
                            Javascript
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div class="row d-flex justify-content-around ">
              <div class="project d-flex flex-row justify-content-around col-lg-3 ">
                <div class="project__card mx-auto">
                  <div class="d-flex flex-row col-lg-3">
                    <div class="d-flex flex-column showcase">
                      <div class="card feature-card">
                        <img class="card-img-top" src={skill} />

                        <div class="card-img-overlay projectOverlay d-flex flex-column align-items-center">
                          <h4
                            class="card-title"
                            style={{ color: "#ff9f1a", fontSize: "28px" }}
                          >
                            Redux-Saga
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="project d-flex flex-row justify-content-around col-lg-3 ">
                <div class="project__card mx-auto">
                  <div class="d-flex flex-row col-lg-3">
                    <div class="d-flex flex-column showcase">
                      <div class="card feature-card">
                        <img class="card-img-top" src={skill} />

                        <div class="card-img-overlay projectOverlay d-flex flex-column align-items-center">
                          <h4
                            class="card-title"
                            style={{ color: "#ff9f1a", fontSize: "28px" }}
                          >
                            HTML5
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="project d-flex flex-row justify-content-around col-lg-3 ">
                <div class="project__card mx-auto">
                  <div class="d-flex flex-row col-lg-3">
                    <div class="d-flex flex-column showcase">
                      <div class="card feature-card">
                        <img class="card-img-top" src={skill} />

                        <div class="card-img-overlay projectOverlay d-flex flex-column align-items-center">
                          <h4
                            class="card-title"
                            style={{ color: "#ff9f1a", fontSize: "28px" }}
                          >
                            CSS3
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="middle-section" ref={page3}>
        <div class="middleimg">
          <div class="row">
            <div class="container col-lg-8">
              <h2 class="middle-para d-inline-block text-center">
                <span>Logic</span> will get you from <span>A to B</span>.
                <span>Imagination</span> will take you <span>everywhere</span>.
              </h2>
            </div>
          </div>
        </div>
      </section>
      <section class="feature page-section" id="service">
        <div class="container d-flex flex-column align-items-center">
          <h2 class="feature-head mb-5">Projects</h2>

          <div class="row d-flex justify-content-around ">
            <div
              class="project d-flex flex-row justify-content-around col-lg-3"
              onClick={() =>
                openInNewTab("https://www.solulab.com/case-studies/doctrace/")
              }
            >
              <div class="project__card mx-auto">
                <div class="d-flex flex-row col-lg-3">
                  <div class="d-flex flex-column showcase">
                    <div class="card feature-card">
                      <img class="card-img-top" src={doctrace} />

                      <div class="card-img-overlay projectOverlay d-flex flex-column align-items-center">
                        <h4
                          class="card-title"
                          style={{ color: "#ff9f1a", fontSize: "28px" }}
                        >
                          Doctrace
                        </h4>
                        <span style={{ color: "#fff", textAlign: "center" }}>
                          Blockchain for Document Management
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="project d-flex flex-row justify-content-around col-lg-3 "
              onClick={() => openInNewTab("https://www.ria.insure")}
            >
              <div class="project__card mx-auto">
                <div class="d-flex flex-row col-lg-3">
                  <div class="d-flex flex-column showcase">
                    <div class="card feature-card">
                      <img
                        class="card-img-top"
                        style={{ height: "170px" }}
                        src={ria}
                      />

                      <div class="card-img-overlay projectOverlay d-flex flex-column align-items-center">
                        <h4
                          class="card-title"
                          style={{ color: "#ff9f1a", fontSize: "28px" }}
                        >
                          Ria
                        </h4>
                        <span style={{ color: "#fff", textAlign: "center" }}>
                          RIA is a health partner to those who wish to live life
                          to the fullest
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="project d-flex flex-row justify-content-around col-lg-3 "
              onClick={() => openInNewTab("https://www.quicksecureloan.com")}
            >
              <div class="project__card mx-auto">
                <div class="d-flex flex-row col-lg-3">
                  <div class="d-flex flex-column showcase">
                    <div class="card feature-card">
                      <img
                        class="card-img-top"
                        style={{ height: "170px" }}
                        src={slm}
                      />

                      <div class="card-img-overlay projectOverlay d-flex flex-column align-items-center">
                        <h4
                          class="card-title"
                          style={{ color: "#ff9f1a", fontSize: "28px" }}
                        >
                          Quicksecureloan
                        </h4>
                        <span style={{ color: "#fff", textAlign: "center" }}>
                          Platform for the management of mortgage loans
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <br />
        </div>
      </section>
      <div class="modal fade" id="myModal">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body d-flex flex-column m-4">
              <h2> Thankyou for contact</h2>

              <button
                type="button"
                class="btn btn-danger lightbox-btn d-flex justify-content-center"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <section class="contact-section py-5 page-section" id="contact">

                <div class="row mx-auto">

                    <div class="container d-flex flex-column align-items-center col">

                        <h2 class="contact-head">Keep in touch</h2>

                        <div id="res" class=""></div>

                        <div class="card contact-card col needs-validation mt-2">

                            <div class="card-body">

                                <form method="post" action="contact_form.php" id="form"
                                    class="d-flex flex-column  align-items-center needs-validation">

                                    <div class="form-group col-lg-8">

                                        <input type="text" class="form-control shadow-none" placeholder="Name" name="name" id="name" required />

                                        <div class="valid-feedback">Valid.</div>

                                        <div class="invalid-feedback">Please fill out this field.</div>

                                    </div>

                                    <div class="form-group  col-lg-8">

                                        <input type="email" class="form-control shadow-none" placeholder="E-mail" name="email" id="email"
                                            required />

                                    </div>

                                    <div class="form-group  col-lg-8">

                                        <textarea class="form-control shadow-none" rows="3" id="comment" placeholder="text"
                                            name="textarea"></textarea>

                                    </div>

                                    <div class="form-group pt-4 col-lg-8">

                                        <input type="submit" class="form-control shadow-none" value="submit" name="submit" id="submit" />

                                    </div>

                                </form>



                            </div>

                        </div>

                    </div>

                </div>

            </section> */}

      <section class="footer-section">
        <div class="row">
          <div class="container d-flex justify-content-center">
            <footer>
              <ul class="footer-order d-flex justify-content-center ">
                {/* <li><a class="footer-link" href="#"><i class="fa fa-facebook-square"></i></a></li> */}

                <li>
                  <a
                    class="footer-link"
                    href="https://www.instagram.com/satish_pillai888/"
                  >
                    <i class="fa fa-instagram"></i>
                  </a>
                </li>

                <li>
                  <a
                    class="footer-link"
                    href="https://www.linkedin.com/in/satish-pillai-899455b2/"
                  >
                    <i class="fa fa-linkedin"></i>
                  </a>
                </li>
              </ul>

              <div class="text-center text-light pl-3">
                Satish Pillai &copy; 2021
              </div>
            </footer>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default Main;
